import type {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from 'next';
import { useRouter } from 'next/router';
import Layout from '@components/common/Layout';
import ProjectView from '@components/project/ProjectView';
import { getProjectAndMoreProjects, getAllProjectsWithSlug } from '@lib/api';

export default function Slug({
  project,
  moreProjects,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter();

  return router.isFallback ? (
    <h1>Loading...</h1>
  ) : (
    <ProjectView project={project} otherProjects={moreProjects} />
  );
}

export async function getStaticProps({
  params,
  preview = false,
}: GetStaticPropsContext<{ slug: string }>) {
  const data = await getProjectAndMoreProjects(params.slug, preview);

  return {
    props: {
      preview,
      project: data?.project || null,
      moreProjects: data?.moreProjects || null,
    },
    revalidate: 7200,
  };
}

export async function getStaticPaths() {
  const allProjects = await getAllProjectsWithSlug();

  return {
    paths:
      allProjects?.map((project) => ({
        params: {
          slug: project.slug,
        },
      })) || [],
    fallback: true,
  };
}

Slug.Layout = Layout;
